<template>
  <header
    :class="headerClasses"
  >
    <div class="container container-header lg-border-left">
      <nav class="header-main__nav">
        <button
          type="button"
          class="nav-toggle"
          :class="navigationToggleClass"
          @click="toggleNavigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <collapse-transition>
          <ul
            class="nav-list"
            v-if="navigationVisible"
            v-click-outside="handleNavigationOutsideClick"
          >
            <li
              v-for="(item, index) in menuItems"
              :key="index"
            >
              <router-link
                v-if="item.to"
                :to="item.to"
                @click.native="hideNavigation"
              >
                {{ item.label }}
              </router-link>
              <a
                v-if="item.url"
                :href="item.url">
                {{ item.label }}
              </a>
            </li>
          </ul>
        </collapse-transition>
      </nav>
      <router-link
        class="header-main__logo"
        :to="{name:'home'}"
      >
        <img
          src="~@/assets/images/logo_internorm.png"
          alt="Logo Internorm"
          class="logo-desktop"
        >
        <img
          v-if="companyInfo.logo"
          :alt="companyInfo.name"
          class="logo-mobile"
          :src="companyInfo.logo"
          >
      </router-link>
      <button
        class="nav-toggle-mobile nav-active"
        type="button"
        @click.stop="openConfigurationsSidebar"
      >
        <span></span>
        <span></span>
        <span></span>
        <span class="units" v-if="configurations.length > 0">
          {{ configurations.length }}
        </span>
      </button>
    </div>
  </header>
</template>

<script>
  import { CollapseTransition } from 'vue2-transitions';
  import { mapGetters, mapState, mapMutations } from 'vuex';

  export default {
    name: 'AppHeader',
    data() {
      return {
        navigationVisible: false,
      };
    },
    methods: {
      ...mapMutations({
        openConfigurationsSidebar: 'openConfigurationsSidebar',
      }),
      toggleNavigation(ev) {
        ev.stopPropagation();
        this.navigationVisible = !this.navigationVisible;
      },
      handleNavigationOutsideClick() {
        if (this.navigationVisible) {
          this.navigationVisible = false;
        }
      },
      hideNavigation() {
        this.navigationVisible = false;
      },
    },
    computed: {
      ...mapState({
        staticPages: state => state.staticPages,
        companyInfo: state => state.companyInfo,
        configurations: state => state.configurations,
      }),
      ...mapGetters({
        completed: 'configurator/completed',
      }),

      navigationToggleClass() {
        return {
          active: this.navigationVisible,
        };
      },
      navigationListStyle() {
        const style = {};

        if (this.navigationVisible) {
          style.display = 'block';
        }

        return style;
      },
      menuItems() {
        const { staticPages, companyInfo, $t } = this;
        const items = [];

        if (companyInfo.url) {
          items.push({
            label: $t('returnToMainPage'),
            url: companyInfo.url.includes('http')
              ? companyInfo.url
              : `http://${companyInfo.url}`,
          });
        }
        
        staticPages.forEach(staticPage => {
          const { title, slug } = staticPage;

          items.push({
            label: title,
            to: { name: 'static', params: { slug } },
          });
        });

         items.push({
            label: $t('contact'),
            to: { name: 'contact' },
          });

        return items;
      },
      headerClasses() {
        const { $route: { meta = {} }, completed } = this;
        let classes = [
          'header-main',
          'is-left-sidebar',
          'is-right-sidebar',
          'fixed-header',
        ];

        if (meta.headerClasses && Array.isArray(meta.headerClasses)) {
          classes = classes.concat(...meta.headerClasses);
        }

        if (completed) {
          let classesSummary = "is-left-sidebar--home";
          classes = classes.concat(classesSummary);
        }

        return classes;
      },
    },
    components: {
      CollapseTransition,
    },
  };
</script>
